<template>
  <div class="section-sign-up-sub-about" data-aos="fade-up" data-aos-once="true">

    <!-- header -->
    <page-subheader title="Signup &amp; Rules"></page-subheader>

    <div-container>

      <div-columns paddingTop="1rem" paddingBottom="0px">
        <h2 style="margin-bottom:0;padding-bottom:15px;">{{ paragraph1.title }}</h2>
      </div-columns>

      <div-columns paddingTop="1em" v-if="imageUrl">
        <div class="columns is-gapless is-centered is-flex-mobile is-vcentered">
          <div class="column is-5 has-text-centered">
            <img :src="imageUrl" width="200" style="width:100%;padding:30px;" />
          </div>
        </div>
      </div-columns>
      <div-columns paddingTop="1em" :class="{ 'with-image': imageUrl !== undefined }">
        <div v-html="paragraph1.content">
        </div>
        <!-- <div class="control notification is-danger" v-if="error">
          <button class="delete" @click="error = undefined"></button>
          <p v-html="error">
          </p>
        </div> -->
        <!-- <div style="margin-top:15px;">
          <h4 class="button is-primary" style="margin:10px;">
            <a href="/static/Team-application.pdf" target="_blank">Team Application</a>
          </h4>
          <h4 class="button is-primary" style="margin:10px;">
            <a href="/static/judge-application.pdf" target="_blank">Judge Application</a>
          </h4>
        </div> -->
        <!-- <div style="margin-top:15px;">
          <h4 class="button is-primary button-disabled" disabled style="margin:10px;">
            <a>Team Application</a>
          </h4>
          <h4 class="button is-primary button-disabled" disabled style="margin:10px;">
            <a>Judge Application</a>
          </h4>
        </div> -->
        <div style="margin-top:15px;">
          <h4 class="button is-primary"
            :class="[(isSignUpTeam ? '' : 'button-disabled')]"
            :disabled="!isSignUpTeam"
            style="margin:10px;">
            <a :href="isSignUpTeam ? '/signup?type=team' : ''" @click="isSignUpTeam ? () => {} : $event.preventDefault()">
              Team Application
            </a>
            <div v-if="teamDisabledText && isSignUpTeamUi"
              class="text-tilted">
              <h4 style="color:#390e07;"
                v-html="teamDisabledText">
              </h4>
            </div>
          </h4>
          <h4 class="button is-primary"
            :class="[(isSignUpJudge ? '' : 'button-disabled')]"
            :disabled="!isSignUpJudge"
            style="margin:10px;position:relative;">
            <a :href="isSignUpJudge ? '/signup?type=judge' : ''" @click="isSignUpJudge ? () => {} : $event.preventDefault()">
              Judge Application
            </a>
            <div v-if="judgeDisabledText && isSignUpJudgeUi"
              class="text-tilted">
              <h4 style="color:#390e07;"
                v-html="judgeDisabledText">
              </h4>
            </div>
          </h4>
        </div>
      </div-columns>

      <div-columns paddingTop="0px" paddingBottom="0px">
        <h2 style="margin-bottom:0;">{{ paragraph2.title }}</h2>
      </div-columns>

      <div-columns paddingTop="0.5em" v-if="imageUrl">
        <div class="columns is-gapless is-centered is-flex-mobile is-vcentered">
          <div class="column is-5 has-text-centered">
            <img :src="imageUrl" width="200" style="width:100%;padding:30px;" />
          </div>
        </div>
      </div-columns>
      <div-columns paddingTop="0.5em" :class="{ 'with-image': imageUrl !== undefined }">
        <div v-html="paragraph2.content">
        </div>
        <!-- <div class="control notification is-danger" v-if="error">
          <button class="delete" @click="error = undefined"></button>
          <p v-html="error">
          </p>
        </div> -->
      </div-columns>

    </div-container>
  </div>
</template>

<script>
// import EventBus from '@/controllers/EventBus'
import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import PageSubheader from '@/components/PageSubheader'
import ShowDown from 'showdown'
import 'showdown-target-blank'

export default {
  name: 'sub-about',
  props: ['name'],
  components: {
    DivContainer,
    DivColumns,
    PageSubheader
  },
  data () {
    return {
      paragraph1: {
        title: '',
        content: ''
      },
      paragraph2: {
        title: '',
        content: ''
      },
      defaultDisabledText: '...',
      teamDisabledText: '',
      judgeDisabledText: '',
      imageUrl: undefined,
      error: undefined,
      loading: false,
      isSignUpTeam: false,
      isSignUpTeamUi: true,
      isSignUpJudge: false,
      isSignUpJudgeUi: true
    }
  },
  computed: {
    // isSignUp: function () {
    //   return EventBus.isSignUp()
    // }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    getItems: function () {
      this.loading = true
      this.error = undefined
      this.imageUrl = undefined
      this.paragraph1.content = ''
      this.paragraph1.title = ''

      this.isSignUpTeam = false
      this.isSignUpTeamUi = true
      this.isSignUpJudge = false
      this.isSignUpJudgeUi = true
      this.teamDisabledText = this.defaultDisabledText
      this.judgeDisabledText = this.defaultDisabledText

      Site.aboutWithName('bosshog::about-sign-up')
      .then((data) => {
        this.loading = false
        // console.log(data)
        if (!data || !data.content) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        var converter = new ShowDown.Converter({ extension: ['targetblank'] })
        var html = converter.makeHtml(data.content)
        this.paragraph1.content = html
        this.paragraph1.title = data.title
        this.imageUrl = data.image ? data.image.path : undefined

        return Site.aboutWithName('bosshog::about-sign-up-rules')
      })
      .then((data) => {
        this.loading = false
        // console.log(data)
        if (!data || !data.content) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        var converter = new ShowDown.Converter({ extension: ['targetblank'] })
        var html = converter.makeHtml(data.content)
        this.paragraph2.content = html.replace('><strong>here</strong>', ' target=&quot;_blank&quot;><strong>here</strong>')
        this.paragraph2.title = data.title
        this.imageUrl = data.image ? data.image.path : undefined

        return Site.aboutWithName('bosshog::about-sign-up-rules')
      })
      .then((data) => {
        return Site.aboutWithName('bosshog::signup-team')
      })
      .then((data) => {
        if (data && data.hasOwnProperty('disabled')) {
          this.isSignUpTeam = !data.disabled
          this.isSignUpTeamUi = data.disabled_ui
          this.teamDisabledText = data.content || this.defaultDisabledText
        }
        return Site.aboutWithName('bosshog::signup-judge')
      })
      .then((data) => {
        if (data && data.hasOwnProperty('disabled')) {
          this.isSignUpJudge = !data.disabled
          this.isSignUpJudgeUi = data.disabled_ui
          this.judgeDisabledText = data.content || this.defaultDisabledText
        }
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },

    refresh: function () {
      this.getItems()
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section about

.section-sign-up-sub-about {
  padding-top: 3rem;
  padding-bottom: 3rem;

  @import "../styles/markdown.scss";

  .text-tilted {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    transform: translate(0,20px);
    transform: rotate(-4deg) translate(-15%,-70%);
    font-size: 0.8em;
  }
}

.button-disabled {
  a {
    color: gray;
    cursor: not-allowed;
  }
}

</style>



// WEBPACK FOOTER //
// AboutSignUpSubSection.vue?c91a2104